<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row" v-if="operators">
        <div class="col-md-12" v-if="filteredOperators && filteredOperators.length>0 || filterQuery || filterCity">
          <div class="panel panel-default">
            <div class="panel-heading">
              <div class="col-md-4">
                Операторы курортного сбора
              </div>
              <div class="col-md-4">
                <div class="be-aside-header-search" v-if="operators.length>5">
                  <div class="input-group input-search input-group-sm">
                    <input v-model="filterQuery" type="text"
                           placeholder="Быстрый поиск по ИНН, названию, адресу, рег. номеру" class="form-control">
                    <span
                      class="input-group-btn">
                      <button type="button" class="btn btn-default"><i class="icon mdi mdi-search"></i></button></span>
                  </div>
                </div>
                <span class="panel-subtitle" v-if="filterQuery" @click="filterQuery=null" style="cursor: pointer">Очистить параметры фильтра </span>
              </div>
              <div class="col-md-4">
                <select class="form-control input-sm" v-model="filterCity">
                  <option selected value="">Все города</option>
                  <option v-for="city in cities" :value="city">
                    <span v-if="city!=='-'">{{city}}</span>
                    <span v-else>Не указан</span>
                  </option>
                </select>
                <span class="panel-subtitle" v-if="filterCity" @click="filterCity=''" style="cursor: pointer">Сбросить параметры (все города)</span>
              </div>
              <router-link :to="{name: 'operator-add'}">
                <button class="btn btn-success btn-lg">
                  <i class="icon icon-left mdi mdi-plus-square"></i>
                  Добавить оператора
                </button>
              </router-link>
              <button v-if="this.$auth.user().is_superuser" class="btn btn-default btn-lg" @click="downloadXls"><i
                class="icon mdi mdi-download">
              </i> Экспорт в xls
              </button>
            </div>
            <div class="panel-body">
              <table class="table table-condensed table-hover table-bordered table-striped">
                <thead>
                <tr>
                  <th class="number">Рег. номер</th>
                  <th>Наименование</th>
                  <th>Форма юр.лица</th>
                  <th style="width:10%;">Фактический адрес нахождения</th>
                  <th>Город</th>
                  <th>Система размещения</th>
                  <th>Вид деятельности (по ОКВЭД)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(operator, index) in filteredOperators">
                  <td class="number">{{ operator.id }}</td>
                  <td>
                    <router-link :to="{name: 'operator-edit', params: {id: operator.id}}">{{ operator.name }}
                    </router-link>
                    <br>
                    ОГРН: {{ operator.ogrn }}<br>
                    ИНН: {{ operator.inn }}<br>
                    КПП: {{ operator.kpp | nullToDashFilter}}
                  </td>
                  <td>{{ getNameFromDict(legalEntityForms, operator.legal_entity_form) }}</td>
                  <td>{{ operator.address }}</td>
                  <td>{{ operator.city | nullToDashFilter}}</td>
                  <td>{{ getNameFromDict(operatorTypes, operator.type) }}</td>
                  <td>{{ operator.okved }}</td>
                </tr>
                </tbody>
              </table>
              <div v-if="filteredOperators.length>0 && (filterQuery|| filterCity)" class="row be-datatable-footer">
                <div class="col-sm-6">
                  <div class="dataTables_info" id="table2_info" role="status" aria-live="polite">
                    <strong>Найдено записей: {{filteredOperators.length}} из {{operators.length}}</strong><br>
                  </div>
                </div>
              </div>
              <div v-if="filteredOperators.length===0 && (filterQuery || filterCity)" class="text-center"
                   style="margin-top: 20px"><h4>
                Операторы с заданными параметрами поиска не найдены</h4></div>
            </div>
          </div>
        </div>
        <div v-if="operators && operators.length===0">
          <router-link :to="{name: 'operator-add'}">
            <button class="btn btn-space btn-success btn-lg pull-left">
              <i class="icon icon-left mdi mdi-plus-square"></i>
              Добавить оператора
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    data: function () {
      return {
        isLoading: false,
        filterQuery: null,
        filterCity: '',
      }
    },
    computed: {
      ...mapGetters(
        {
          operatorTypes: 'operatorTypes',
          legalEntityForms: 'legalEntityForms',
          regions: 'regions',
          privilegeCategories: 'privilegeCategories',
          operators: 'operators'
        }
      ),
      cities () {
        let cities = []
        this.operators.forEach(item => (cities.push(item.city)))
        return [...new Set(cities)].sort()
      },
      filteredOperators () {
        if (this.filterQuery || this.filterCity) {
          let operators = this.operators
          if (this.filterCity) {
            let city = this.filterCity.toLowerCase()
            operators = operators.filter(operator => {
              return operator.city ? operator.city.toLowerCase().includes(city) : false
            })
            if (city === '') {
              operators = operators.filter(operator => {
                return operator.city === '-'
              })
            }
          }
          if (this.filterQuery) {
            let query = this.filterQuery.toLowerCase()
            operators = operators.filter(operator => {
              let id = String(operator.id).toLowerCase().includes(query)
              let name = operator.name.toLowerCase().includes(query)
              let inn = operator.inn.toLowerCase().includes(query)
              let address = operator.address ? operator.address.toLowerCase().includes(query) : false
              let city = operator.city ? operator.city.toLowerCase().includes(query) : false
              let type = operator.type ? this.operatorTypes.find(item => Number(item.id) === Number(operator.type)).name.toLowerCase().includes(query) : false
              return (
                name || inn || address || city || type || id
              )
            })
          }
          return operators
        } else {
          return this.operators
        }
      }
    },
    methods: {
      downloadXls () {
        axios({
          url: '/api/operators/generate_xls/',
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let fileName = 'Реест операторов курортного сбора.xls'
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      },
      fetchData: function () {
        this.isLoading = true
        var self = this
        axios.get('/api/operators/')
          .then(function (response) {
            self.operators = response.data
            self.isLoading = false
          })
          .catch(function (error) {
            self.isLoading = false
          })
      },
      getNameFromDict (dictName, id) {
        if (dictName.length > 0 && id) {
          return dictName.find(item => Number(item.id) === Number(id)
          ).name
        } else {
          return "\t—"
        }
      },
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/operators/OperatorList.vue